<template>
  <div class="page stackingplan-page">
    <filters/>

    <div v-if="group" class="stackingplan-navigator">
      <div @click="toOverview" class="stackingplan-navigator-header" :class="{ active: isOverview }">
        Overzicht
      </div>
      <div class="stackingplan-navigator-items">
        <div v-for="(building, i) in buildings" class="stackingplan-navigator-items__item" :class="{ active: $route.fullPath.includes(building.slug)}" :key="i" @click="toBuilding(building)">{{ building.building_name }}</div>
      </div>
      <div class="stackingplan-navigator-nav">
        <router-link v-if="!singleMap" :to="prevGroup" class="icon-caret-left stackingplan-navigator-nav-left"></router-link>
        <span v-if="group" class="stackingplan-navigator-nav-title" :class="{'single-map': singleMap}">{{ group.title }}</span>
        <router-link v-if="!singleMap" :to="nextGroup" class="icon-caret-right stackingplan-navigator-nav-right"></router-link>
      </div>
    </div>


    <main @click="getCoordinates" :class="imageRatio" >
      <div v-if="map" class="stackingplan-wrapper" >
        <div class="position-relative stackingplan-wrapper-inner">
          <img :src="map.image" :alt="map.name" class="stackingplan-map-image">

          <svg class="stackingplan-map stackingplan-default-map" :class="{ filtered: $filtersActive, noFilter: !$filtersActive, highlight: $highlight }" viewBox="0 0 1000 1000">
            <stackingplan-polygon
                    v-for="(pointer, i) in map.pointers"
                    :key="i" :index="i"
                    :active="i === mapIndex && !popupMap"
                    :selectedPol="selectedPolMap"
                    :pointer="pointer"
                    :map="getMap(pointer.map)"
            />
          </svg>
        </div>
      </div>

        <div v-if="popupMap" class="stackingplan-popup-wrapper" :class="isHorizontal ? 'stackingplan-popup-wrapper-horizontal' : 'stackingplan-popup-wrapper-vertical'">

          <button class="icon-cross close-popup" @click="routeBack()"></button>
          <div class="stackingplan-popup-map">
            <h3 class="keep-polygon-active">{{ popupMap.name }}</h3>
            <div class="position-relative">
              <img :src="popupMap.image" :alt="popupMap.name" class="stackingplan-map-image">
              <svg class="stackingplan-map stackingplan-map__popup" viewBox="0 0 1000 1000">
                <stackingplan-polygon
                    v-for="(pointer, i) in popupMap.pointers"
                    :key="i"
                    :index="i"
                    :selectedPol="selectedPolFloor"
                    :pointer="pointer"
                    :map="getMap(pointer.map)"
                />
              </svg>
            </div>
          </div>

          <div class="stackingplan-popup-footer keep-polygon-active">
            <div  v-if="active_polygon" >
              <house-tile v-if="pointer.link_type === 'eyemove_id'" :house="$getObject(pointer.eyemove_id)" :houseindex="pointer.eyemove_id"/>
            </div>
          </div>
        </div>

      <div v-if="active_polygon && pointer.link_type !== 'eyemove_id'" class="stackingplan-map-infobox" :class="{showleft: teaserPosition}" :style="{left: clicked.x +'px', top: (clicked.y +  (scrolledFromTop + clickedOffset) ) +'px'}">
        <building-teaser-popup v-if="pointer.link_type === 'map'" :map="getMap(pointer.map)" />
      </div>

      <selector-list
          :mapheight="imgHeightList"
      />

      <house-tile-slider
        v-if="gotObjects && mapIndex !== null"
        ref="houseslider"
      ></house-tile-slider>

    </main>
  </div>
</template>

<script>
  import Filters from '../components/Filters.vue'
  import StackingplanPolygon from "../components/StackingplanPolygon";
  import BuildingTeaserPopup from "../components/BuildingTeaserPopup"
  import HouseTile from "../components/HouseTile";
  import HouseTileSlider from '../components/HouseTileSlider.vue'
  import SelectorList from '../components/SelectorList.vue'
  const VueScrollTo = require('vue-scrollto');


  export default {
    components: {
      HouseTile,
      HouseTileSlider,
      BuildingTeaserPopup,
      StackingplanPolygon,
      SelectorList,
      Filters,
    },
    data() {
      return {
        active_polygon: null,
        selectedPolMap: undefined,
        selectedPolFloor: undefined,
        map_popup: null,
        mapIndex: null,
        scrolledFromTop: 0,
        clickedOffset: 0,
        clicked: {
          x: 0,
          y: 0
        },
        teaserPosition: false,
        imageRatio: '',
      }
    },

    created() {
      if (this.map) {
        this.mapWidth = parseInt(this.map.width);
        this.mapHeight = parseInt(this.map.height)
      }
      this.calcHeightList();
      this.$nextTick(() => {
          this.scrollCenter();
      })
    },

    mounted() {
        if(!this.group){
          let group = this.$store.state.apiData.groups[0];
          let url = '/' + this.$route.params.selector_id + '/stackingplan/' + group.slug + '/' + group.map_slug;
          this.$router.replace(url)
        }
        if(!this.map){
          let url = '/' + this.$route.params.selector_id + '/stackingplan/' + this.group.slug + '/' + this.group.map_slug;
          this.$router.replace(url)
        }
        this.setImageRatio();

      const stackingplainWrapper = document.getElementsByClassName('stackingplan-wrapper')[0];

      stackingplainWrapper.addEventListener('scroll', () => {
        this.scrolledFromTop = -stackingplainWrapper.scrollTop;
      });
    },

    methods: {
        showTile(tileIndex, mapIndex){
          this.mapIndex = mapIndex;
          this.$nextTick(() => {
            if(this.$refs.houseslider) {
              this.$refs.houseslider.slideTo(tileIndex);
            }
          });
        },
        noActivePolygon(){
          this.mapIndex = null;
        },
        routeBack(){
            let paths = window.location.pathname.split('/')
            let url = '';
            let stop = false;
            paths.forEach((path) => {
              if (path === 'popover') {
                stop = true
              }
              if(stop) return
              if (path) {
                url += '/' + path
              }

            })
            this.$router.push(url)
            setTimeout(function(){
                if(window.location.pathname.includes('popover')){
                    document.body.classList.add('popuppage');
                }
                else {
                    document.body.classList.remove('popuppage');
                }
            }, 100);


        },
      setImageRatio() {
        if (this.mapWidth < this.mapHeight) {
          this.imageRatio = 'portrait'
          this.landscapemode = false

        } else {
          this.imageRatio = 'landscape'
          this.landscapemode = true
        }
      },
      getMap(id) {
        return this.maps.find((map) => {
          return id && map.id.toString() === id.toString()
        })
      },
      getCoordinates(c) {

        const stackingplainWrapper = document.getElementsByClassName('stackingplan-wrapper')[0];

        this.clickedOffset = stackingplainWrapper.scrollTop;

        if(c.target.classList.contains('stackingplan-map-infobox')) {
          return
        }
        if (c.target.dataset.id) {
          this.active_polygon = c.target.dataset.id
        }
        else if (event.target.classList.contains('keep-polygon-active')) {
            this.active_polygon = this.active_polygon
        }
        else {
          this.active_polygon = null;
          this.selectedPolMap = undefined
        }

        let offset = 0;

        if(this.agent === 'chrome'){
          offset = 60;
        }

        if(this.agent === 'firefox'){
          offset = 20;
        }

        if(this.agent === 'safari'){
         // offset = -10;
        }

        this.clicked = {
          x: c.clientX + 10,
          y: c.clientY - 75
        }

        var halfScreen = window.innerWidth / 2;

        if (this.clicked.x <= halfScreen) {
            this.teaserPosition = false
          this.clicked.x -= 20

        }
        else {
            this.teaserPosition = true
        }

      },
      toOverview()
      {
        let url = this.basePath + '/' + this.group.slug  + '/' + this.group.map_slug
        this.$router.push(url)
      },
      toBuilding(building)
      {
        let path = building.paths[building.paths.length - 1]
        let url = this.basePath + '/' + path + '/' + building.slug
        this.$router.push(url)
      },




      calcHeightList() {
          const calc = this.map.width / 100;
          this.imgHeightList = this.map.height / calc
      },


      getPolygonIndexMap (i) {
          // Set index from clicked polygon
          this.selectedPolMap = i
      },
      getPolygonIndexFloor (i) {
          // Set index from clicked polygon
          this.selectedPolFloor = i

      },

      scrollCenter() {
          const imageheight = window.innerWidth / this.mapWidth * this.mapHeight
          const wrapheight = window.innerHeight - 120
          const toscroll = (imageheight - wrapheight) / 2

          VueScrollTo.scrollTo('.stackingplan-wrapper-inner', {
              container: '.stackingplan-wrapper',
              easing: 'linear',
              offset: toscroll,
              duration: 1,
          })
      }
    },
    computed: {
      agent(){
        let ua = navigator.userAgent.toLowerCase();
        if(ua.includes('chrome')){
          return 'chrome';
        }
        if(ua.includes('safari')){
          return 'safari';
        }

        if(ua.includes('firefox')){
          return 'firefox';
        }
        return null;
      },
      buildings()
      {
        return this.$store.state.apiData.maps.filter((map) => {
          return map.building_name
        })
      },
      isHorizontal(){
        const ratio = this.popupMap.width / this.popupMap.height;

        return ratio > 1.10
      },
      gotObjects(){
        return this.map.pointers.filter(p => p.link_type === 'eyemove_id' && p.eyemove_id).length
      },
      path() {
        return this.$route.params.pathMatch
      },
      maps() {
        return this.$store.state.apiData.maps
      },
      pointer() {
        let pointer = this.map.pointers.find((pointer) => {
          return pointer.id.toString() === this.active_polygon
        })

        if(!pointer){
          pointer = this.popupMap.pointers.find((pointer) => {
            return pointer.id.toString() === this.active_polygon
          })
        }

        return pointer
      },
      lastMapSlug() {
        let path = this.path ? this.path.split('/') : []
        let slug = ''
        let stop = false
        path.forEach((p) => {
          if(p === 'popover'){
            stop = true;
          }
          if(!stop) {
            slug = p
          }
        })
        return slug
      },
      isOverview(){
        return this.lastSlug === this.group.map_slug
      },
      lastSlug() {
        let path = this.path ? this.path.split('/') : []
        return path.length ? path[path.length - 1] : null
      },
      group(){
        let path = window.location.pathname.split('/')
        let slug = path.find((slug) => {
          return slug.startsWith('group-')
        })
        let groups = this.$store.state.apiData.groups
        return groups.find((group) => {
          return group.slug === slug
        })
      },
      singleMap(){
        return this.$store.state.apiData.groups.length === 1;
      },
      prevGroup(){
        let groups = this.$store.state.apiData.groups;
        let index = groups.findIndex((group) => {
          return group.slug === this.group.slug
        }) - 1
        let group = groups[index] ? groups[index] : groups[groups.length - 1]
        return this.basePath + '/' + group.slug + '/' + group.map_slug
      },
      basePath(){
        return '/' + this.$route.params.selector_id + '/stackingplan'
      },
      nextGroup(){
        let groups = this.$store.state.apiData.groups
        let index = groups.findIndex((group) => {
          return group.slug === this.group.slug
        }) + 1

        let group = groups[index] ? groups[index] : groups[0]
        return this.basePath + '/' + group.slug + '/' + group.map_slug
      },
      map() {
        if (!this.path) {
          return null
        }

        // get the corresponding map
        return this.maps.find((map) => {
          return map.slug === this.lastMapSlug
        })
      },
      popupMap() {
        if(!window.location.pathname.includes('popover')){
            return null
        }
        else {
            document.body.classList.add('popuppage');
        }
        return this.maps.find((map) => {
          return map.slug === this.lastSlug
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .stackingplan-wrapper {
    position: fixed;
    top:120px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;

  }

  .popuppage .stackingplan-default-map .blink {
    fill: rgba(0,0,0,0) !important;
  }

  .single-map {
    justify-content: center !important;
  }
  @media (max-width: 768px) {
    .stackingplan-wrapper {
      top: 72px;
    }
  }

  .stackingplan-map-image {
    width: 100%;
  }

  .stackingplan-popup-footer {
    position: relative !important;
  }


</style>
